export const theme = {
  token: {
    borderRadius: 8,
    controlHeight: 32,
    colorLink: '#ebb23c',
    colorText: '#3c3c3b',
    colorError: '#ff4040',
    colorPrimary: '#02b1a9',
    colorSuccess: '#00c781',
    colorWarning: '#ffbb38',
    fontFamily: 'Inter, sans-serif',
  },
}
